/**
 * @generated SignedSource<<d7720e402543707f1f68ab122292e49a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PhoneChangeMutationInput = {
  clientMutationId?: string | null;
  newPhone: string;
};
export type PhoneEditFormUpdateMutation$variables = {
  input: PhoneChangeMutationInput;
};
export type PhoneEditFormUpdateMutation$data = {
  readonly phoneChange: {
    readonly __typename: "Influencer";
    readonly newPhone: string | null;
  } | {
    readonly __typename: "PhoneChangeError";
    readonly errorType: string;
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type PhoneEditFormUpdateMutation = {
  response: PhoneEditFormUpdateMutation$data;
  variables: PhoneEditFormUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newPhone",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "PhoneChangeError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PhoneEditFormUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phoneChange",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PhoneEditFormUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phoneChange",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5fb816a223a2ffdf8f3fd27e0e519e35",
    "id": null,
    "metadata": {},
    "name": "PhoneEditFormUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation PhoneEditFormUpdateMutation(\n  $input: PhoneChangeMutationInput!\n) {\n  phoneChange(input: $input) {\n    __typename\n    ... on Influencer {\n      newPhone\n      id\n    }\n    ... on PhoneChangeError {\n      errorType\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b642c3992cee20cfb29210e8110094ed";

export default node;
